import { Col, Row } from 'react-bootstrap'
import { useMutation } from 'react-query'

import useContainerContext from '../../containerContext'
import { DocumentHeader, HeaderButton, VehicleItem } from '../../shared'
import ModalPhotoList from '../../ModalPhotoList'
import useAppContext from '../../app'
import { useApi, useLoading } from '../../../hooks'
import toast from '../../toast'

const WorkOrderDetail = () => {
  const { store: { isLog } } = useAppContext()
  const { data, state, showPhotoModal, closeModalPhoto } = useContainerContext()
  const { showModalPhoto, vehicle: modalVehicle, initialSlide } = state
  const { company, vehicle = {}, client: { _id: client = {} } = {}, assignedTo = [] } = data
  let isShowPdf = true
  let showScans = true

  if (!isLog) {
    const token = localStorage['access_token']
    const payload = token ? JSON.parse(window.atob(token.split('.')[1])) : null
    isShowPdf = payload?.pdf
    showScans = payload?.scans !== false
  }

  const companyProps = (() => {
    if (client.group && client.group.companyOverride && client.group.companyOverride.active) return client.group.companyOverride
    return company
  })()
  const companyLogo = companyProps.logo || company?.logo || null

  const { pdfService } = useApi()
  const { isLoading, mutate: downloadPdf } = useMutation(
    params => pdfService.workorderPDF(params, false),
    { onError: error => toast.error({ title: 'View PDF errors', body: error.message }) }
  )
  useLoading(isLoading)

  return (
    <div className='my-5 px-sm-3'>
      <Row>
        <Col md={12}>
          <div className='pt-4'>
            <DocumentHeader
              documentType="Work Order"
              documentNumber={data.number}
              dateCreated={data.dateCreated}
              createdBy={data.createdBy?.name}
              client={client}
              company={companyProps}
              companyLogo={companyLogo}
              showTotal={false}
              onBack={() => window.history.back()}
              detailRows={
                assignedTo.length > 0 ? (
                  <span className="document-detail-item">
                    Assigned to: {assignedTo.map(a => a.user?.name).filter(Boolean).join(', ')}
                  </span>
                ) : null
              }
              buttons={
                isShowPdf ? (
                  <HeaderButton variant="primary" onClick={() => downloadPdf({ recordId: data._id })}>
                    VIEW PDF
                  </HeaderButton>
                ) : null
              }
            />

            <div className='mt-3'>
              <VehicleItem
                record={data}
                isWorkOrder={true}
                index={0}
                vehicle={vehicle}
                onShowPhoto={showPhotoModal}
                showScans={showScans}
              />
            </div>
          </div>
        </Col>
      </Row>

      {showModalPhoto && <ModalPhotoList vehicle={modalVehicle} initialSlide={initialSlide} onClose={closeModalPhoto} />}
    </div>
  )
}

export default WorkOrderDetail
